import 'antd/dist/antd.css';

import { Button, Input, Message, NumberPicker } from '@alifd/next';
import { DollarCircleFilled } from '@ant-design/icons';
import { createTheme, ThemeProvider } from '@mui/material';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, message, Modal } from 'antd'; // dialog UI
import locale from 'antd/lib/date-picker/locale/zh_TW';
import axios from 'axios';
import zhTW from 'date-fns/locale/zh-TW';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import LoadingSpin from '@/components/UI/LoadingSpin';
import Tab from '@/components/UI/mobile/Tab';
import PointManagementFrontDeskList from '@/pages/PointManagementFrontDesk/components/PointManagementFrontDeskList';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';
import { muiThemeComponents } from './muiThemeComponents';

const theme = createTheme({
  components: muiThemeComponents,
});

const PublicFrontDesk = () => {
  const week = ['一', '二', '三', '四', '五', '六', '日'];
  const publicInformationHour = client.service('publicInformationHour');
  const publicInformationCount = client.service('publicInformationCount');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const publicAppointmentHour = client.service('publicAppointmentHour');
  const publicAppointmentCount = client.service('publicAppointmentCount');
  const communityData = client.service('communityData');

  const [usersHouseholdNumbers, setUsersHouseholdNumbers] = useState('');
  const [usersName, setUsersName] = useState('');

  const [appointmentHourArr, setAppointmentHourArr] = useState([]);
  const [appointmentCountArr, setAppointmentCountArr] = useState([]);
  const [appointmentAllow, setAppointmentAllow] = useState([]);
  const [appointmentNumber, setAppointmentNumber] = useState(null);
  const [appointmentAllowDialog, setAppointmentAllowDialog] = useState(false);
  const [addStatus, setAddStatus] = useState(false);
  const user = useSelector((state) => state.user);
  const [allowedFuncs, setAllowedFuncs] = useState([]);
  const [usersFinalPoints, setUsersFinalPoints] = useState('');
  const [showPointsDialog, setShowPointsDialog] = useState(false);
  const start = moment();
  const [searchTime, setSearchTime] = useState([
    moment(start).minutes(0).seconds(0),
    moment(start).add(1, 'hours').minutes(0).seconds(0),
  ]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [communityDataObject, setCommunityDataObject] = useState({});
  const [tab, setTab] = useState(0);

  const [publicInformationHourArr, setPublicInformationHourArr] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // 公設查看Dialog
  const [appointmentPublicHourDialog, setAppointmentPublicHourDialog] =
    useState(false);
  const [
    appointmentPublicHourDetailDialog,
    setAppointmentPublicHourDetailDialog,
  ] = useState(false);
  const [
    appointmentPublicCountDetailDialog,
    setAppointmentPublicCountDetailDialog,
  ] = useState(false);

  // 公設查看

  const [peopleNumberValue, setPeopleNumberValue] = useState(1);
  const [publicAppointmentDateValue, setPublicAppointmentDateValue] =
    useState('');
  const [timeItem, setTimeItem] = useState('請先選擇時段');
  const [onChangeDate, setOnChangeDate] = useState(false);

  const [showPublic, setShowPublic] = useState(false);
  const [publicObject, setPublicObject] = useState({});
  const [publicNum, setPublicNum] = useState(0);

  useEffect(() => {
    if (user.userGroup.key) {
      const checkedKeys = user.userGroup.key.checkedKeys;
      setAllowedFuncs(checkedKeys);
      // setManager(user.userGroup.name); // 紀錄管理者權限
    }
  }, [user]);

  useEffect(() => {
    (async () => {
      const data = await client.reAuthenticate();
      setUsersName(data.user.name);
      setUsersHouseholdNumbers(
        !Object.prototype.hasOwnProperty.call(data.user, 'householdNumbers') ||
          data.user.householdNumbers.length === 0
          ? false
          : data.user.householdNumbers
      );
      // 點數資訊
      const residentAccountNumbersArr = await residentAccountNumbers.find({
        query: {
          householdNumber: {
            $in: data.user.householdNumbers,
          },
        },
      });
      setUsersFinalPoints(
        residentAccountNumbersArr.data[0].finalPoints +
          residentAccountNumbersArr.data[0].buyPoint
      );

      // 計時預約資訊
      const publicAppointmentHourArr = await publicAppointmentHour.find({
        query: {
          householdNumber: { $in: data.user.householdNumbers },
          $sort: {
            createdTime: -1,
          },
        },
      });
      setAppointmentHourArr(
        publicAppointmentHourArr.data.filter((item) => {
          if (tab === 0) {
            return item.status === '預約中';
          } else if (tab === 1) {
            return item.status === '已入場';
          } else if (tab === 2) {
            return (
              item.status === '已離場' ||
              item.status === '已取消' ||
              item.status === '未入場'
            );
          }
        })
      );
      // 計次預約資訊
      const publicAppointmentCountArr = await publicAppointmentCount.find({
        query: {
          householdNumber: { $in: data.user.householdNumbers },
          $sort: {
            createdTime: -1,
          },
        },
      });
      setAppointmentCountArr(
        publicAppointmentCountArr.data.filter((item) => {
          if (tab === 0) {
            return item.status === '預約中';
          } else if (tab === 1) {
            return item.status === '已入場';
          } else if (tab === 2) {
            return (
              item.status === '已離場' ||
              item.status === '已取消' ||
              item.status === '未入場'
            );
          }
        })
      );

      // 社區基本資料
      const communityDataArr = await communityData.find({});
      setCommunityDataObject(communityDataArr.data[0]);

      //剩餘公設資訊
      axios
        .get(
          `/ezcon/api/noUseAppointment?timeStart=${searchTime[0]
            .startOf('second')
            .valueOf()}&timeEnd=${searchTime[1]
            .startOf('second')
            .valueOf()}&householdNumber=${data.user.householdNumbers[0]}`,
          {
            headers: {
              authorization: localStorage.getItem('feathers-jwt'),
            },
          }
        )
        .then((res) => {
          console.log(res.data);

          setPublicInformationHourArr(res.data);
          setIsLoading(false);
        });
    })();
  }, [
    tab,
    publicAppointmentCount,
    publicAppointmentHour,
    isUpdate,
    communityData,
    residentAccountNumbers,
    searchTime,
  ]);

  useEffect(() => {
    client.io.on('inPublic', () => {
      setIsUpdate((pre) => !pre);
    });
  }, []);
  const disabledDate = (current) => {
    return current && current < moment().startOf('day');
  };

  const disabledPublicDate = (current) => {
    return (
      current < moment().startOf('day') ||
      publicObject.dayAllowTime[moment(current).isoWeekday() - 1].length ===
        0 ||
      current >
        moment().add(
          publicObject.publicExpireTimeNum,
          publicObject.publicExpireTimeUnit
        )
    );
  };
  return (
    <>
      {/* 小時預約 */}
      <Modal
        closable={false}
        className={styles.modal2}
        okButtonProps={
          usersFinalPoints - publicObject?.publicDeductPoints < 0 &&
          allowedFuncs.includes('點數前台')
            ? { disabled: true }
            : { disabled: false }
        }
        mask={false}
        visible={appointmentPublicHourDetailDialog}
        onOk={() => {
          if (!usersHouseholdNumbers) {
            Message.error('尚未開通戶號');
            return;
          }
          if (publicAppointmentDateValue === '') {
            Message.error('請選擇日期');
            return;
          }
          console.log(timeItem);
          if (timeItem === '請先選擇時段') {
            Message.error('請選擇時段');
            return;
          }

          publicAppointmentHour
            .create({
              publicName: publicObject.publicName,
              householdNumber: usersHouseholdNumbers[0],
              userName: usersName,
              publicAppointmentNumber: parseInt(peopleNumberValue, 10),
              publicUseTime: publicObject.publicUsageTime,
              publicAppointmentDate: moment(
                `${moment(publicAppointmentDateValue).format(
                  'YYYY/MM/DD'
                )} ${timeItem}`
              ).valueOf(),
              publicAppointmentTime: timeItem,
              publicDeductPointsValue:
                publicObject?.PointDeductType === 'byPersion'
                  ? publicObject?.publicDeductPoints * peopleNumberValue
                  : publicObject?.publicDeductPoints,
              targetId: publicObject._id,
              appointmentData: [[timeItem, parseInt(peopleNumberValue, 10)]],
              isDeductionPoint: false,
              files: publicObject.files,
              status: '預約中',
            })
            .then((res) => {
              console.log('==publicAppointmentHour create  success:', res);
              setPeopleNumberValue(1);
              setPublicAppointmentDateValue('');
              setTimeItem('請先選擇時段');
              setAppointmentPublicHourDetailDialog(false);
              setShowPublic(false);
              Message.success('預約成功');
              setIsUpdate((pre) => !pre);
            })
            .catch((error) => {
              console.log('==publicAppointmentHour create  fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setPeopleNumberValue(1);
          setPublicAppointmentDateValue('');
          setTimeItem('請先選擇時段');
          setAppointmentPublicHourDetailDialog(false);
        }}
        okText="送出"
        cancelText="取消"
      >
        <div className={styles.appointmentContainer}>
          <div className={styles.appointmentBox}>
            <div className={styles.usersHouseholdNumbersText}>戶號</div>
            <div className={styles.usersHouseholdNumbers}>
              {usersHouseholdNumbers
                ? usersHouseholdNumbers[0]
                : '尚未開通戶號'}
            </div>
            <div className={styles.usersNameText}>用戶名</div>
            <div className={styles.usersName}> {usersName}</div>

            <div className={styles.publicAppointmentDateValueText}>
              請選擇日期
            </div>

            <DatePicker
              disabledDate={disabledPublicDate}
              size="large"
              className={styles.publicAppointmentDateValue}
              placeholder="選擇日期"
              value={publicAppointmentDateValue}
              locale={locale}
              inputReadOnly
              onChange={(value) => {
                setPublicAppointmentDateValue(value);
                setOnChangeDate(true);
                setTimeItem('請先選擇時段');
              }}
            />
            <div className={styles.timeItemText}>預約時段</div>
            <div className={styles.timeItemBox}>
              <div className={styles.timeItem}>
                {onChangeDate === true ? timeItem : timeItem || '請先選擇時段'}
              </div>
              <Button
                className={styles.timeItemBtn}
                // disabled={timeItem ? false : true}
                type="primary"
                onClick={async () => {
                  if (publicAppointmentDateValue === '') {
                    message.error('請選擇日期');
                    return;
                  }
                  const res = await axios.get(
                    `/ezcon/api/appointmentPeopleNumber?time=${moment(
                      publicAppointmentDateValue
                    ).valueOf()}&publicName=${publicObject.publicName}`,
                    {
                      headers: {
                        authorization: localStorage.getItem('feathers-jwt'),
                      },
                    }
                  );
                  console.log(res.data);
                  setAppointmentAllow(res.data);
                  setAppointmentAllowDialog(true);
                }}
              >
                {onChangeDate === true || timeItem
                  ? onChangeDate === true
                    ? '選擇時段'
                    : '選擇時段'
                  : '選擇時段'}
              </Button>
            </div>
            {timeItem !== null && timeItem !== '請先選擇時段' && (
              <>
                <div className={styles.peopleNumberText}>人數</div>
                <NumberPicker
                  size="large"
                  className={styles.peopleNumberValue}
                  trim
                  min={1}
                  max={publicNum}
                  // max=
                  placeholder="請輸入人數(限數字)"
                  value={peopleNumberValue}
                  onChange={(value) => {
                    setPeopleNumberValue(value);
                  }}
                />
              </>
            )}
            <div className={styles.publicUsageTimeText}>使用時間限制</div>
            <div className={styles.publicUsageTime}>
              {publicObject.publicUsageTime}小時
            </div>
            {allowedFuncs.includes('點數前台') && (
              <div>
                <div className={styles.publicUsageTimeText}>現有點數</div>
                <div className={styles.usersName}>{usersFinalPoints}</div>
                {/* <div className={styles.publicUsageTimeText}>已使用點數</div>
                <div className={styles.usersName}>- {useTotalPoints}</div> */}
                <div className={styles.publicUsageTimeText}>
                  <div></div>
                  本次使用點數
                  {publicObject?.PointDeductType === 'byPersion'
                    ? '(依人數扣點' + publicObject.publicDeductPoints + '點/人)'
                    : '(本次使用點數' +
                      publicObject.publicDeductPoints +
                      '點/次)'}
                  {/* {publicObject.publicAppointmentNumber} */}
                </div>
                <div className={styles.usersName}>
                  -
                  {publicObject?.PointDeductType === 'byPersion'
                    ? publicObject?.publicDeductPoints * peopleNumberValue
                    : publicObject?.publicDeductPoints}
                </div>
                <hr style={{ margin: '10px 0' }} />
                <div className={styles.publicUsageTimeText}>預計剩餘點數</div>
                <div className={styles.usersName}>
                  {publicObject?.PointDeductType === 'byPersion'
                    ? usersFinalPoints -
                      publicObject?.publicDeductPoints * peopleNumberValue
                    : usersFinalPoints - publicObject?.publicDeductPoints}
                  {/* {usersFinalPoints - publicObject?.publicDeductPoints} */}
                </div>
                {usersFinalPoints - publicObject?.publicDeductPoints < 0 && (
                  <div className={styles.publicUsageTime}>
                    點數不足，無法預約公設
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal>
      {/* AppointmentAllowDialog 時段表 */}
      <Modal
        closable={false}
        className={styles.modal}
        // width={"100vw"}
        okText
        title={`選擇預約時段，每時段最多${publicObject.publicMaxAppointmentsNumber}人`}
        mask={false}
        // footer={null}
        visible={appointmentAllowDialog}
        onCancel={() => {
          setAppointmentAllowDialog(false);
        }}
        cancelText="關閉"
      >
        <div className={styles.timeContainer}>
          {Object.entries(appointmentAllow).map(([key, value]) => {
            return (
              <Button
                disabled={
                  value >=
                    parseInt(publicObject.publicMaxAppointmentsNumber, 10) ||
                  (moment(key, 'HH:mm').valueOf() <
                    moment()
                      .subtract(publicObject.publicUsageTime, 'h')
                      .valueOf() &&
                    moment(publicAppointmentDateValue).format('YYYY-MM-DD') ===
                      moment().format('YYYY-MM-DD'))
                }
                className={styles.timeBox}
                key={key}
                onClick={() => {
                  setAppointmentAllowDialog(false);
                  setTimeItem(key);
                  setPublicNum(
                    publicObject.publicMaxAppointmentsNumber - value
                  );
                }}
              >
                {`${key}${' '}
                    ${value}/${publicObject.publicMaxAppointmentsNumber}`}
              </Button>
            );
          })}
        </div>
      </Modal>
      {/* 每次預約 */}
      <Modal
        closable={false}
        className={styles.modal2}
        // width={"100vw"}
        // title={`${publicName} 預約單`}
        okButtonProps={
          usersFinalPoints - publicObject.publicDeductPoints < 0 &&
          allowedFuncs.includes('點數前台')
            ? { disabled: true }
            : { disabled: false }
        }
        mask={false}
        visible={appointmentPublicCountDetailDialog}
        onOk={() => {
          if (!usersHouseholdNumbers) {
            Message.error('尚未開通戶號');
            return;
          }
          if (publicAppointmentDateValue === '') {
            Message.error('請選擇日期');
            return;
          }
          if (
            parseInt(appointmentNumber, 10) ===
            parseInt(publicObject.publicMaxAppointmentsNumber, 10)
          ) {
            Message.error('預約人數已滿');
            return;
          }

          publicAppointmentCount
            .create({
              createdTime: new Date().getTime(),
              updatedTime: new Date().getTime(),
              publicName: publicObject.publicName,
              householdNumber: usersHouseholdNumbers[0],
              userName: usersName,
              publicAppointmentNumber: parseInt(peopleNumberValue, 10),
              publicAppointmentDate: moment(publicAppointmentDateValue).format(
                'YYYY/MM/DD'
              ),
              publicDeductPointsValue:
                publicObject?.PointDeductType === 'byPersion'
                  ? publicObject.publicDeductPoints * peopleNumberValue
                  : publicObject.publicDeductPoints,
              targetId: publicObject._id,
              isDeductionPoint: false,
              status: '預約中',
              files: publicObject.files,
              useTime:
                publicObject.dayAllowTime[
                  moment(publicAppointmentDateValue).isoWeekday() - 1
                ],
            })
            .then((res) => {
              console.log('==create AppointmentCount success:', res);
              setAppointmentPublicCountDetailDialog(false);

              setPeopleNumberValue(1);
              setPublicAppointmentDateValue('');
              setShowPublic(false);

              Message.success('預約成功');
              setIsUpdate((pre) => !pre);
            })
            .catch((error) => {
              console.log('==create AppointmentCount fail:', error);
              Message.error(`${error}`);
            });
        }}
        onCancel={() => {
          setPeopleNumberValue(1);
          setPublicAppointmentDateValue('');
          setAppointmentPublicCountDetailDialog(false);
        }}
        okText="送出"
        cancelText="取消"
      >
        <div className={styles.appointmentContainer}>
          <div className={styles.appointmentBox}>
            <div className={styles.usersHouseholdNumbersText}>戶號</div>
            <div className={styles.usersHouseholdNumbers}>
              {usersHouseholdNumbers
                ? usersHouseholdNumbers[0]
                : '尚未開通戶號'}
            </div>
            <div className={styles.usersNameText}>用戶名</div>
            <div className={styles.usersName}> {usersName}</div>
            <div className={styles.peopleNumberText}>請選擇日期</div>
            <DatePicker
              disabledDate={disabledPublicDate}
              size="large"
              placeholder="選擇日期"
              locale={locale}
              inputReadOnly
              className={styles.publicAppointmentDateValue}
              value={publicAppointmentDateValue}
              onChange={(value) => {
                setPublicAppointmentDateValue(value);
                axios('/ezcon/api/findAppointmentCount', {
                  method: 'POST',
                  headers: {
                    authorization: window.localStorage['feathers-jwt'],
                  },
                  data: {
                    targetId: publicObject._id,
                    publicAppointmentDate: moment(value).format('YYYY/MM/DD'),
                  },
                }).then((res) => {
                  setAppointmentNumber(res.data.publicAppointmentNumber);
                });
              }}
            />
            {publicAppointmentDateValue !== '' && (
              <div className={styles.appointmentNumber}>
                目前預約狀況:{' '}
                {`${appointmentNumber}/${publicObject.publicMaxAppointmentsNumber} `}
                {parseInt(appointmentNumber, 10) ===
                  parseInt(publicObject.publicMaxAppointmentsNumber, 10) &&
                  '(已滿人)'}
              </div>
            )}
            {publicAppointmentDateValue && (
              <>
                <div className={styles.peopleNumberText}>人數</div>
                <NumberPicker
                  size="large"
                  className={styles.peopleNumberValue}
                  trim
                  defaultValue={1}
                  min={1}
                  max={parseInt(publicObject.publicMaxAppointmentsNumber, 10)}
                  placeholder="請輸入人數(限數字)"
                  value={peopleNumberValue}
                  onChange={(value) => {
                    setPeopleNumberValue(value);
                  }}
                />
                <div className={styles.publicAppointmentDateValueText}>
                  請選擇日期
                </div>
              </>
            )}

            {allowedFuncs.includes('點數前台') && (
              <div>
                <div className={styles.publicUsageTimeText}>現有點數</div>
                <div className={styles.usersName}>{usersFinalPoints}</div>
                <div className={styles.publicUsageTimeText}>
                  本次使用點數{' '}
                  {publicObject?.PointDeductType === 'byPersion'
                    ? '(依人數扣點' + publicObject.publicDeductPoints + '點/人)'
                    : '(本次使用點數' +
                      publicObject.publicDeductPoints +
                      '點/次)'}
                </div>
                <div className={styles.usersName}>
                  -
                  {publicObject?.PointDeductType === 'byPersion'
                    ? publicObject?.publicDeductPoints * peopleNumberValue
                    : publicObject?.publicDeductPoints}
                </div>

                <hr style={{ margin: '10px 0' }} />

                <div className={styles.publicUsageTimeText}>預計剩餘點數</div>
                <div className={styles.usersName}>
                  {publicObject?.PointDeductType === 'byPersion'
                    ? usersFinalPoints -
                      publicObject?.publicDeductPoints * peopleNumberValue
                    : usersFinalPoints - publicObject?.publicDeductPoints}
                </div>

                {usersFinalPoints - publicObject.publicDeductPoints < 0 && (
                  <div className={styles.publicUsageTime}>
                    點數不足，無法預約公設
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </Modal>
      {/* 查看preview */}
      <Modal
        closable={false}
        okText
        className={styles.modal}
        // width={"100vw"}
        mask={false}
        visible={appointmentPublicHourDialog}
        onOk={() => {
          setAppointmentPublicHourDialog(false);
        }}
        onCancel={() => {
          setAppointmentPublicHourDialog(false);
        }}
        cancelText="關閉"
      >
        <div className={styles.previewContainer}>
          <div className={styles.previewBox}>
            <div className={styles.previewLeftBox}>
              <img
                className={styles.img2}
                src={
                  publicObject.files && publicObject.files.length > 0
                    ? publicObject.files[0].response.showPath
                    : '/ezcon/icon/ic_photo.svg'
                }
                alt="IMG"
              />
              <div className={styles.publicItem}>公設名稱</div>
              <div className={styles.publicName}>{publicObject.publicName}</div>
              <div className={styles.publicContent}>
                <pre>{publicObject.publicContent}</pre>
              </div>
              <div className={styles.openTime}>開放時間</div>
              {publicObject?.dayAllowTime?.map((dayItem, index) => (
                <div className={styles.openTimeShow} key={index}>
                  <div>星期{week[index]}:</div>
                  <div>
                    {dayItem.length === 0 && <div>非開放</div>}
                    {dayItem.length > 0 &&
                    dayItem[0][0] === 0 &&
                    dayItem[0][1] === 24 ? (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          textAlign: 'right',
                        }}
                      >
                        <div>24小時開放</div>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          textAlign: 'right',
                        }}
                      >
                        {dayItem.map((timeItem, timeIndex) => (
                          <div key={timeIndex}>
                            {timeItem[0]}:00–{timeItem[1]}:00
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <div className={styles.description}>租借說明</div>
              <div
                className={styles.publicMultipleAppointments}
              >{`是否同時段多人預約: ${publicObject.publicMultipleAppointments}`}</div>
              <div
                className={styles.publicMaxAppointmentsNumber}
              >{`容納人數: ${publicObject.publicMaxAppointmentsNumber}人`}</div>
              {publicObject?.publicUsageTime && (
                <div
                  className={styles.publicUsageTime}
                >{`使用時間限制: ${moment()
                  .startOf('d')
                  .add(publicObject.publicUsageTime, 'h')
                  .format('HH小時mm分鐘')}`}</div>
              )}
              <div className={styles.rentalEquipment}>
                可租借設備:
                {publicObject.publicRentalEquipment?.length > 0 ? (
                  publicObject.publicRentalEquipment.map((list, index) => {
                    return (
                      <span
                        className={styles.publicRentalEquipment}
                        key={index}
                      >
                        {list}
                      </span>
                    );
                  })
                ) : (
                  <span className={styles.publicRentalEquipment}> 無</span>
                )}
              </div>
              {allowedFuncs.includes('點數前台') && (
                <div
                  className={styles.rentalEquipment}
                >{`扣點方式: ${publicObject.publicDeductPoints} 點/次`}</div>
              )}
            </div>

            <div className={styles.previewRightBox}>
              <div className={styles.imgText}>圖片</div>
              <img
                className={styles.img}
                src={
                  publicObject.files && publicObject.files.length > 0
                    ? publicObject.files[0].response.showPath
                    : '/ezcon/icon/ic_photo.svg'
                }
                alt="IMG"
              />
            </div>
          </div>
        </div>
      </Modal>
      {/* 公設預約時間查詢 */}
      <Modal
        closable={false}
        className={styles.modal3}
        // width={"100vw"}
        mask={false}
        visible={addStatus}
        onOk={() => {
          setAddStatus(false);
        }}
        onCancel={() => {
          setAddStatus(false);
        }}
        okText="關閉"
        cancleBtn={false}
      >
        <div className={styles.informationContainerBox}>
          <div className={styles.searchTime}>
            <ThemeProvider theme={theme}>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={zhTW}
              >
                <Stack spacing={3}>
                  <DateTimePicker
                    label="開始時間"
                    value={searchTime[0]}
                    onChange={(value) => {
                      console.log(value);
                      const newSearchTime = [...searchTime];
                      newSearchTime[0] = moment(value).minutes(0).seconds(0);
                      setSearchTime(newSearchTime);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                    inputFormat="yyyy/MM/dd HH:mm"
                    shouldDisableDate={disabledDate}
                  />
                  <DateTimePicker
                    label="結束時間"
                    value={searchTime[1]}
                    onChange={(value) => {
                      const newSearchTime = [...searchTime];
                      newSearchTime[1] = moment(value).minutes(0).seconds(0);
                      setSearchTime(newSearchTime);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                    inputFormat="yyyy/MM/dd HH:mm"
                    shouldDisableDate={(current) => {
                      return (
                        current && current < moment(searchTime[0]).valueOf()
                      );
                    }}
                  />
                </Stack>
              </LocalizationProvider>
            </ThemeProvider>

            <Button
              type="primary"
              className={styles.searchBtn}
              onClick={() => {
                if (publicInformationHourArr.length > 0) {
                  setAddStatus(false);
                  setShowPublic(true);
                } else {
                  Message.error('此時段無未預約公設');
                }
              }}
            >
              查詢
            </Button>
          </div>
        </div>
      </Modal>
      {/* 查詢剩餘公設 */}
      <Modal
        closable={false}
        className={styles.modal2}
        // width={"100vw"}
        mask={false}
        visible={showPublic}
        onOk={() => {
          setShowPublic(false);
        }}
        onCancel={() => {
          setAddStatus(true);
          setShowPublic(false);
        }}
        okText="關閉"
        cancelText="返回"
      >
        <div className={styles.informationContainerBox}>
          {publicInformationHourArr.map((item, index) => {
            return (
              <div key={index} className={styles.informationContainer}>
                <div className={styles.informationBox}>
                  <div className={styles.informationLeft}>
                    <img
                      className={styles.informationImg}
                      src={
                        item.files && item.files.length > 0
                          ? item.files[0].response.showPath
                          : '/ezcon/icon/ic_photo.svg'
                      }
                      alt="IMG"
                      onClick={() => {
                        setAppointmentPublicHourDialog(true);
                        setPublicObject(item);
                      }}
                    />
                    <div className={styles.informationText}>
                      <div
                        className={styles.publicName}
                        onClick={() => {
                          setAppointmentPublicHourDialog(true);
                          setPublicObject(item);
                        }}
                      >
                        {item.publicName}
                      </div>
                      <div className={styles.openTime}>開放時間</div>
                      {item.dayAllowTime.map((dayItem, index) => (
                        <div className={styles.openTimeShow} key={index}>
                          <div>星期{week[index]}:</div>
                          <div>
                            {dayItem.length === 0 && <div>非開放</div>}
                            {dayItem.length > 0 &&
                            dayItem[0][0] === 0 &&
                            dayItem[0][1] === 24 ? (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  textAlign: 'right',
                                }}
                              >
                                <div>24小時開放</div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  textAlign: 'right',
                                }}
                              >
                                {dayItem.map((timeItem, timeIndex) => (
                                  <div key={timeIndex}>
                                    {timeItem[0]}:00–{timeItem[1]}:00
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className={styles.informationBtn2Box}>
                    <Button
                      disabled={item.isAppointmentFull}
                      type="primary"
                      className={
                        item.isAppointmentFull
                          ? styles.disableBtn
                          : styles.informationBtn2
                      }
                      onClick={() => {
                        setPublicObject(item);
                        if (item?.publicUsageTime) {
                          setAppointmentPublicHourDetailDialog(true);
                        } else {
                          setAppointmentPublicCountDetailDialog(true);
                        }

                        if (!item?.publicUsageTime) {
                          axios('/ezcon/api/findAppointmentCount', {
                            method: 'POST',
                            headers: {
                              authorization:
                                window.localStorage['feathers-jwt'],
                            },
                            data: {
                              targetId: item._id,
                              publicAppointmentDate:
                                moment().format('YYYY/MM/DD'),
                            },
                          })
                            .catch((error) => {
                              console.log(
                                '==findAppointmentCount find fail:',
                                error
                              );
                            })
                            .then((res) => {
                              setAppointmentNumber(
                                res.data.publicAppointmentNumber
                              );
                            });
                        }
                      }}
                    >
                      {item.isAppointmentFull ? '不可預約' : ' 預約'}
                    </Button>
                  </div>
                  <div className={styles.informationRight}>
                    <Button
                      disabled={item.isAppointmentFull}
                      type="primary"
                      className={
                        item.isAppointmentFull
                          ? styles.disableBtn
                          : styles.informationBtn
                      }
                      onClick={() => {
                        setPublicObject(item);

                        if (item?.publicUsageTime) {
                          setAppointmentPublicHourDetailDialog(true);
                        } else {
                          setAppointmentPublicCountDetailDialog(true);
                        }

                        if (!item?.publicUsageTime) {
                          axios('/ezcon/api/findAppointmentCount', {
                            method: 'POST',
                            headers: {
                              authorization:
                                window.localStorage['feathers-jwt'],
                            },
                            data: {
                              targetId: item._id,
                              publicAppointmentDate:
                                moment().format('YYYY/MM/DD'),
                            },
                          })
                            .catch((error) => {
                              console.log(
                                '==findAppointmentCount find fail:',
                                error
                              );
                            })
                            .then((res) => {
                              console.log(
                                '==findAppointmentCount find success:',
                                res.data
                              );

                              setAppointmentNumber(
                                res.data.publicAppointmentNumber
                              );
                            });
                        }
                      }}
                    >
                      {item.isAppointmentFull ? '不可預約' : ' 預約'}
                    </Button>
                  </div>
                </div>
                {publicInformationHourArr.length !== index + 1 && (
                  <div className={styles.divider} />
                )}
              </div>
            );
          })}
        </div>
      </Modal>
      {/* 我的預約 */}
      <div className={styles.mobilePublicContainer}>
        <div className={styles.mobilePublicBackground} />
        {allowedFuncs.includes('點數前台') && (
          <div className={styles.pointTotal}>
            <div className={styles.pointColumn}>
              <img
                src={`icon/ic_point_blue.svg`}
                alt="ic_point_blue"
                style={{ width: '4vw' }}
              />
              <span style={{ marginLeft: 10, color: '#000000' }}>點數</span>
              <span style={{ marginLeft: 10 }} className={styles.pointNum}>
                {usersFinalPoints}
              </span>
            </div>
            <div className={styles.pointColumn}>
              <Button
                className={styles.showPointHistory}
                onClick={() => {
                  setShowPointsDialog(true);
                }}
              >
                點數記錄
              </Button>
            </div>
          </div>
        )}

        <div className={styles.publicHeader}>
          <Button
            type="primary"
            className={styles.myAppointmentBtn}
            onClick={() => {
              setAddStatus(true);
              // serverDataUpdateInformationHour();
            }}
          >
            新增公設預約
          </Button>
        </div>
        <div className={styles.record}>
          <Tab
            options={['我的預約', '目前使用', '歷史資料']}
            onChange={setTab}
          />
        </div>

        {isLoading ? (
          <LoadingSpin />
        ) : (
          <>
            {appointmentHourArr.map((item, index) => {
              return (
                <div key={index}>
                  <div className={styles.appStatus}>
                    <div
                      className={
                        (item.status === '預約中' && styles.statusBlue) ||
                        (item.status === '已入場' && styles.statusGreen) ||
                        ((item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場') &&
                          styles.statusGray)
                      }
                    >
                      {item.status}
                    </div>
                  </div>
                  <div
                    className={styles.myAppointmentContainer}
                    style={{
                      border:
                        appointmentHourArr.length === index + 1 &&
                        appointmentCountArr.length === 0 &&
                        0,
                    }}
                  >
                    <div className={styles.imgBox}>
                      <img
                        className={styles.myAppointmentImg}
                        src={
                          item.files && item.files.length > 0
                            ? item.files[0].response.showPath
                            : '/ezcon/icon/ic_photo.svg'
                        }
                        alt="IMG"
                        onClick={async () => {
                          const res = await publicInformationHour.find({
                            query: { publicName: item.publicName },
                          });
                          setPublicObject(res.data[0]);

                          setAppointmentPublicHourDialog(true);
                        }}
                      />
                    </div>
                    <div className={styles.nameBox}>
                      <div
                        className={styles.publicName}
                        onClick={async () => {
                          const res = await publicInformationHour.find({
                            query: { publicName: item.publicName },
                          });
                          setPublicObject(res.data[0]);
                          setAppointmentPublicHourDialog(true);
                        }}
                      >
                        {item.publicName}
                      </div>
                      <div className={styles.dateText}>預約日期</div>
                      <div className={styles.date}>{`${moment(
                        item.publicAppointmentDate
                      ).format('YYYY-MM-DD')}  `}</div>
                      <div className={styles.date}>{`${
                        item.publicAppointmentTime
                      }~${moment(item.publicAppointmentTime, 'HH:mm')
                        .add(item.publicUseTime, 'hours')
                        .format('HH:mm')}`}</div>
                      <div className={styles.propleText2}>預約人數</div>
                      <div className={styles.prople2}>
                        {item.publicAppointmentNumber}
                      </div>
                    </div>
                    <div className={styles.propleBox}>
                      <div className={styles.propleText}>預約人數</div>
                      <div className={styles.prople}>
                        {item.publicAppointmentNumber}
                      </div>
                    </div>
                    <div
                      className={
                        (item.status === '預約中' && styles.statusBlue) ||
                        (item.status === '已入場' && styles.statusGreen) ||
                        ((item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場') &&
                          styles.statusGray)
                      }
                    >
                      {item.status}
                    </div>
                    <div className={styles.myCancleBtnBox}>
                      <Button
                        disabled={
                          item.publicAppointmentDate -
                            communityDataObject.publicAppointmentHourCancelTime <=
                            moment().valueOf() ||
                          item.isDeductionPoint ||
                          item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '已入場' ||
                          item.status === '未入場'
                        }
                        className={
                          item.publicAppointmentDate -
                            communityDataObject.publicAppointmentHourCancelTime <=
                            moment().valueOf() ||
                          item.isDeductionPoint ||
                          item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '已入場' ||
                          item.status === '未入場'
                            ? styles.disableBtn
                            : styles.cancleBtn
                        }
                        type="secondary"
                        onClick={() => {
                          Swal.fire({
                            title: '取消預約',
                            text: '取消後將無法復原該時段預約!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('取消', '取消預約成功', 'success');
                              publicAppointmentHour
                                .patch(appointmentHourArr[index]._id, {
                                  ...appointmentHourArr[index],
                                  status: '已取消',
                                })

                                .then(() => {
                                  setIsUpdate((pre) => !pre);
                                })
                                .catch((err) => {
                                  console.log(
                                    '==delete  appointmentHourArr Data fail:',
                                    err
                                  );
                                });
                            }
                          });
                        }}
                      >
                        取消預約
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}

            {appointmentCountArr.map((item, index) => {
              return (
                <div key={index}>
                  <div className={styles.appStatus}>
                    <div
                      className={
                        (item.status === '預約中' && styles.statusBlue) ||
                        (item.status === '已入場' && styles.statusGreen) ||
                        ((item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場') &&
                          styles.statusGray)
                      }
                    >
                      {item.status}
                    </div>
                  </div>
                  <div
                    className={styles.myAppointmentContainer}
                    style={{
                      border: appointmentCountArr.length === index + 1 && 0,
                    }}
                  >
                    <div className={styles.imgBox}>
                      <img
                        className={styles.myAppointmentImg}
                        src={
                          item.files && item.files.length > 0
                            ? item.files[0].response.showPath
                            : '/ezcon/icon/ic_photo.svg'
                        }
                        alt="IMG"
                        onClick={async () => {
                          const res = await publicInformationCount.find({
                            query: { publicName: item.publicName },
                          });
                          setPublicObject(res.data[0]);
                          setAppointmentPublicHourDialog(true);
                        }}
                      />
                    </div>
                    <div className={styles.nameBox}>
                      <div
                        className={styles.publicName}
                        onClick={async () => {
                          // setPublicObject(item);
                          const res = await publicInformationCount.find({
                            query: { publicName: item.publicName },
                          });
                          setPublicObject(res.data[0]);

                          setAppointmentPublicHourDialog(true);
                        }}
                      >
                        {item.publicName}
                      </div>
                      <div className={styles.dateText}>預約日期</div>
                      <div className={styles.date}>{`${moment(
                        item.publicAppointmentDate
                      ).format('YYYY-MM-DD')} `}</div>
                      <div className={styles.propleText2}>預約人數</div>
                      <div className={styles.prople2}>
                        {item.publicAppointmentNumber}
                      </div>
                    </div>
                    <div className={styles.propleBox}>
                      <div className={styles.propleText}>預約人數</div>
                      <div className={styles.prople}>
                        {item.publicAppointmentNumber}
                      </div>
                    </div>
                    <div
                      className={
                        (item.status === '預約中' && styles.statusBlue) ||
                        (item.status === '已入場' && styles.statusGreen) ||
                        ((item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場') &&
                          styles.statusGray)
                      }
                    >
                      {item.status}
                    </div>
                    <div className={styles.myCancleBtnBox}>
                      <Button
                        disabled={
                          item.isDeductionPoint ||
                          item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場' ||
                          item.status === '已入場' ||
                          moment(item.publicAppointmentDate, 'YYYY/MM/DD')
                            .startOf('d')
                            .valueOf() -
                            communityDataObject.publicAppointmentCountCancelTime <=
                            moment(
                              `${item.useTime[0][0]}:00`,
                              'HH:mm'
                            ).valueOf()
                        }
                        className={
                          item.isDeductionPoint ||
                          item.status === '已取消' ||
                          item.status === '已離場' ||
                          item.status === '未入場' ||
                          item.status === '已入場' ||
                          moment(item.publicAppointmentDate, 'YYYY/MM/DD')
                            .startOf('d')
                            .valueOf() -
                            communityDataObject.publicAppointmentCountCancelTime <=
                            moment(
                              `${item.useTime[0][0]}:00`,
                              'HH:mm'
                            ).valueOf()
                            ? styles.disableBtn
                            : styles.cancleBtn
                        }
                        type="secondary"
                        onClick={() => {
                          Swal.fire({
                            title: '取消預約',
                            text: '取消後將無法復原該時段預約!!',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#BEBEBE',
                            confirmButtonText: '確定',
                            cancelButtonText: '取消',
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire('取消', '取消預約成功', 'success');
                              publicAppointmentCount
                                .patch(appointmentCountArr[index]._id, {
                                  ...appointmentCountArr[index],
                                  status: '已取消',
                                })
                                .then((res) => {
                                  console.log(
                                    '==delete appointmentHourArr Data success:',
                                    res
                                  );
                                  // 20220406 移除paereload()修改為DataUpdate
                                  // serverDataUpdateAppointmentCount({
                                  //   householdNumber: usersHouseholdNumbers[0],
                                  // });
                                  setIsUpdate((pre) => !pre);

                                  // serverDataUpdateInformationHour();
                                })
                                .catch((err) => {
                                  console.log(
                                    '==delete  appointmentHourArr Data fail:',
                                    err
                                  );
                                });
                            }
                          });
                        }}
                      >
                        取消預約
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
            {!appointmentHourArr.length > 0 &&
            !appointmentCountArr.length > 0 ? (
              <div className={styles.record}>
                尚無
                {(tab === 0 && '預約') ||
                  (tab === 1 && '使用') ||
                  (tab === 2 && '歷史')}
                紀錄
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      {/* 彈跳點數儲值 */}
      <Modal
        closable={false}
        className={styles.modal}
        // width={"100vw"}
        okText
        mask={false}
        visible={showPointsDialog}
        onOk={() => {
          setShowPointsDialog(false);
          setIsUpdate((prev) => !prev);
        }}
        onCancel={() => {
          setShowPointsDialog(false);
          setIsUpdate((prev) => !prev);
        }}
        cancelText="關閉"
      >
        <PointManagementFrontDeskList />
      </Modal>
    </>
  );
};

export default PublicFrontDesk;
